import React from "react";

import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { renderToStaticMarkup } from "react-dom/server";
import { useTranslation } from "react-i18next";

import { APP_TOOLTIP_ID } from "@/src/constants/tooltip";

import AdminUserAPI from "../../../api/AdminUserAPI";
import { DATE_FORMAT_WITH_TIME } from "../../../constants/dateFormat";

import type { JSX } from "react";

interface SelectedMediaOwnerInfoProps {
  updatedAt: string;
  userId?: string;
}

export default function SelectedMediaOwnerInfo({
  updatedAt,
  userId = "",
}: SelectedMediaOwnerInfoProps): JSX.Element | null {
  const { t } = useTranslation("editor-fast-channel");

  const userProfileQuery = AdminUserAPI.generateQuery({
    fn: AdminUserAPI.getSingleAdminUser,
    params: [userId],
  });

  const { data: ownerData } = useQuery({
    ...userProfileQuery,
    enabled: Boolean(userId),
  });

  if (!ownerData) return null;

  return (
    <div
      className="mr-[1.25rem] ml-auto size-[2.5rem] shrink-0 rounded-full bg-cover bg-center"
      data-tooltip-id={APP_TOOLTIP_ID}
      data-tooltip-html={renderToStaticMarkup(
        <div className="flex gap-[0.46875rem]">
          <div className="flex flex-col items-start gap-[0.46875rem]">
            <div>{t("scheduledBy")}</div>
            <div>{t("updated")}</div>
          </div>
          <div className="flex flex-col items-end gap-[0.46875rem]">
            <div>
              <strong>{`${ownerData.first_name} ${ownerData.last_name}`}</strong>
            </div>
            <div>
              <strong>{moment(updatedAt).format(DATE_FORMAT_WITH_TIME)}</strong>
            </div>
          </div>
        </div>,
      )}
      style={{
        backgroundImage: `url(${ownerData.avatar_url})`,
      }}
    />
  );
}
